/*
 * Module for Direct Deposit step
 */
rs.module("content/employmentseparationoptions/directdeposit",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, getBankUrl) {
            var notOnFileDisclaimer = $.js(jsSelectors.notOnFileDisclaimer, { required: false });
            var unknownBankFlag = $.js(jsSelectors.unknownBankFlag, { required: false });

            const routingNumberInput = $.js(jsSelectors.routingNumber);
            const bankNameInput = $.js(jsSelectors.bankName);

            if (routingNumberInput && bankNameInput) {
                // Validate routing number format (9 digits)
                routingNumberInput.on('blur', function () {
                    const value = $(this).val().replace(/\D/g, ''); // Remove non-digits
                    
                    if (value.length === 9) {
                        $.post(getBankUrl, { abaNumber: routingNumberInput.val() })
                            .done(function (result) {

                                // Show disclaimer if routing number cannot be found
                                if (result.bankName != null) {
                                    bankNameInput.val(result.bankName);
                                    showNotOnFileDisclaimer(false);
                                }
                                else
                                {
                                    bankNameInput.val('Unknown Bank');
                                    showNotOnFileDisclaimer(true);
                                }
                            })
                            .fail(function () {
                                bankNameInput.val('Unknown Bank');
                                showNotOnFileDisclaimer(true);
                            });
                    }
                });

                routingNumberInput.on('input', function () {
                    // Only allow numeric input
                    $(this).val($(this).val().replace(/\D/g, ''));
                    
                    // Limit to 9 characters
                    if ($(this).val().length > 9) {
                        $(this).val($(this).val().slice(0, 9));
                    }

                    bankNameInput.val('');
                    showNotOnFileDisclaimer(false);
                });
            }

            // Hide or show the not on file disclaimer
            function showNotOnFileDisclaimer(show) {
                if (show) {
                    notOnFileDisclaimer.show();
                    unknownBankFlag.val("true");
                }
                else {
                    notOnFileDisclaimer.hide();
                    unknownBankFlag.val("false");
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
